<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      Total Count (Project)
    </h1>
    <div v-if="dataNotNull" key="1" class="projectCountDiv"
         style="width: 100%; height: 100%;margin-top: 5%; position: absolute; bottom: 0">
      <div class="select"
           style="position: absolute; right: 5%; z-index: 9;width: 13%;">
        <el-select v-model="default_tag"
                   placeholder="请选择" popper-class="optionsContent"
                   @change="switch_tag">
          <el-option
            v-for="item in multi_tags"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="container1" style="height: 100%;margin-top: 5%"></div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {

  name: "safety",

  props: ['project_id'],

  data() {
    return {
      legendArr: [],
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "safety",
      dataNotNull: true,
      default_tag: "Daily",
      multi_tags: [
        {label: "Daily", value: "0"},
        {label: "Monthly", value: "1"},
        // {label: "Acc.", value: "2"},
        // {label: "Last Month", value: "3"},
      ],
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    switch_tag(label) {
      this.getData(label)
    },

    analysisResult(result) {
      var pcounts = []
      var legends = []
      for (var i in result) {
        legends.push(result[i].org_type)
        pcounts.push(result[i].count)
      }
      return {legends: legends, pcounts: pcounts}
    },
    getData(label) {
      let postData = {
        proj_id: this.project_id,
        bes_project_id: window.localStorage.getItem('bes_project_id'),
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token'),
        period: label,
      }
      axios.post(this.$store.getters.getHCSServer + "ProjCount", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        this.myChart.hideLoading()
        if (errNo == "0") {
          this.dataNotNull = true
          var result = resp.data.result;
          var data = this.analysisResult(result)
          this.myChart.setOption({
            xAxis: {
              data: data.legends,
            },
            series: [
              {
                data: data.pcounts
              }
            ]
          })
        } else {
          this.dataNotNull = false
        }
      }).catch(error => {
        alert(error)
        this.myChart.hideLoading()
        this.dataNotNull = false
      })

    }
  },
  mounted() {
    let that = this
    this.myChart = echarts.init(document.querySelector('.projectCountDiv .container1'))
    this.myChart.setOption({
      grid: {
        bottom: 100
      },
      tooltip: {
        show: true,
        trigger: 'axis',
        textStyle: {
          fontSize: 40
        }
      },
      xAxis: {
        type: "category",
        data: [],
        axisLine: {
          lineStyle: {
            color: '#FFF',
          }
        },
        axisLabel: {
          interval: 0,
          fontSize: 36
        }
      },
      yAxis: {
        type: 'value',
        minInterval: 1,
        axisLine: {
          lineStyle: {
            color: '#6CF',
          },

        },
        axisLabel: {
          fontSize: 42
        }
      },
      series: [{
        data: [],
        barWidth: '25%',
        barCategoryGap: '5%',
        type: 'bar',
        itemStyle: {
          normal: {
            color: function (params) {
              return that.color[params.dataIndex]
            }
          },
          //鼠标悬停时：
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }],
    })

    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });

    let postData = {
      proj_id: this.project_id,
      bes_project_id: window.localStorage.getItem('bes_project_id'),
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token'),
      period: '0',
      // start_date: this.getNowFormatDate(),
      // end_date: this.getNowFormatDate()
    }
    axios.post(this.$store.getters.getHCSServer + "ProjCount", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      this.myChart.hideLoading()
      if (errNo == "0") {
        this.dataNotNull = true
        var result = resp.data.result;
        var data = this.analysisResult(result)
        this.myChart.setOption({
          xAxis: {
            data: data.legends,
          },
          series: [
            {
              data: data.pcounts
            }
          ]
        })
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert(error)
      this.myChart.hideLoading()
      this.dataNotNull = false
    })
    // this.init()
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/HCS/projectcount.vue